import { useEffect, useState } from 'react'
import { getPermissions } from '../../../crud/integration.crud'

const useIsAuthorized = ({ integrationAppName, selectedCustomerId, initialState = false }) => {
  const [isAuthorized, setIsAuthorized] = useState(initialState)

  useEffect(() => {
    const getAuthorization = async () => {
      try {
        const result = await getPermissions(integrationAppName, selectedCustomerId)
        setIsAuthorized(result?.data?.AuthorizationStatus === 'Authorized')
      } catch (exception) {
        setIsAuthorized(false)
      }
    }

    if (integrationAppName && selectedCustomerId) {
      getAuthorization()
    }
  }, [integrationAppName, selectedCustomerId])

  return isAuthorized
}

export default useIsAuthorized
